// LAYOUT
// ----------------------------------------------------------------------

export const DRAWER_WIDTH = 260;

export const NAVBAR_HEIGHT = 80;
export const SIDEBAR_WIDTH_MOBILE = 240;
export const SIDEBAR_WIDTH_DESKTOP = 280;

export const SIDEBAR_ROOT_ITEM_HEIGHT = 48;
export const SIDEBAR_SUB_ITEM_HEIGHT = 40;
export const SIDEBAR_ICON_ITEM_SIZE = 22;



// SETTINGS
// ----------------------------------------------------------------------